<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <div class="md-layout md-size-100">
        <div class="md-layout-item md-size-20 md-small-size-50 order-header">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>equalizer</md-icon>
              </div>
              <p class="category">UNIQUE CUSTOMERS</p>
              <h3 class="title">
                <animated-number :key="boxTop.unique_customers" :value="boxTop.unique_customers"></animated-number>
              </h3>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50 order-header">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>equalizer</md-icon>
              </div>
              <p class="category">UNIQUE TRANSACTIONS</p>
              <h3 class="title">
                <animated-number :key="boxTop.unique_transactions" :value="boxTop.unique_transactions"></animated-number>
              </h3>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50 order-header">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>equalizer</md-icon>
              </div>
              <p class="category">TOTAL PROCESSED</p>
              <h3 class="title"> {{ revenue }} </h3>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50 order-header">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>equalizer</md-icon>
              </div>
              <p class="category">REWARDS PROCESSED</p>
              <h3 class="title"> {{ rewards }} </h3>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-20 md-small-size-50 order-header">
          <stats-card header-color="green">
            <template slot="header">
              <div class="card-icon">
                <md-icon>equalizer</md-icon>
              </div>
              <p class="category">FEE REVENUE</p>
              <h3 class="title"> {{ fee_revenue }} </h3>
            </template>
          </stats-card>
        </div>
        <div class="md-layout-item md-size-100">
          <div class="md-layout-item md-size-100">
            <div class="md-gutter md-alignment-top-right">
              <date-range-picker v-model="calendarPeriod" :startDate="calendarPeriod.startDate" :endDate="calendarPeriod.endDate" :locale-data="calendarLocale" :ranges="ranges" opens="right">
                <md-input v-model="calendarPeriod" slot-scope="picker">Days Interval</md-input>
              </date-range-picker>
              <div id="downloadBtn" class="md-layout-item" v-if="csvOrders == null">
                <md-button class="exportBtns" @click="downloadCsvData">
                  {{ this.downloadTitle }}
                </md-button>
              </div>
              <div id="exportBtn" class="md-layout-item" v-if="csvOrders != null">
                <md-button>
                  <download-csv class="exportBtns" name="admin-export.csv" :data="csvOrders" :fields="exportFields" :labels="exportLabels">
                    Download Report
                    <md-icon>cloud_download</md-icon>
                  </download-csv>
                </md-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>assignment</md-icon>
              </div>
              <h4 class="title">Sales Report</h4>
            </md-card-header>
            <md-card-content>
              <md-table id="ordersTable" :value="fulfilledOrders" :md-sort.sync="fulfilledOrdersCurrentSort" :md-sort-order.sync="fulfilledOrdersCurrentSortOrder" :md-sort-fn="fulfilledCustomSort" class="paginated-table table-striped table-hover">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Order Time">{{ item.order_time | moment }}</md-table-cell>
                  <md-table-cell md-label="Pickup Time">{{ item.pickup_time | moment }}</md-table-cell>
                  <md-table-cell md-label="Merchant Name">{{item.merchant_name}}</md-table-cell>
                  <md-table-cell md-label="Address">{{ item.merchant_address }}</md-table-cell>
                  <md-table-cell md-label="Name">{{ item.order_name }}</md-table-cell>
                  <md-table-cell md-label="Email">{{ item.user_email }}</md-table-cell>
                  <md-table-cell md-label="Platform">{{ item.platform }}</md-table-cell>
                  <md-table-cell md-label="Detail">{{ item.order_details }}</md-table-cell>
                  <md-table-cell md-label="Sub Total">{{ formatDouble(item.sub_total) }}</md-table-cell>
                  <md-table-cell md-label="Tax">{{ formatDouble(item.tax) }}</md-table-cell>
                  <md-table-cell md-label="Tip">{{ formatDouble(item.tip) }}</md-table-cell>
                  <md-table-cell md-label="Fee">{{ formatDouble(item.service_fee) }}</md-table-cell>
                  <md-table-cell md-label="Reward">{{ formatDouble(item.reward_value) }}</md-table-cell>
                  <md-table-cell md-label="Total">{{ formatDouble(item.total_price) }}</md-table-cell>
                  <md-table-cell md-label="Delete">
                    <md-button class="md-just-icon md-danger md-simple" @click.native="showDeleteConfirm(item, false)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell />
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <div class="">
                <p class="card-category">
                  Showing {{ fulfilled_orders_from + 1 }} to {{ fulfilled_orders_to }} of {{ fulfilled_total }} entries
                </p>
              </div>
              <pagination class="pagination-no-border pagination-success" v-model="fulfilledOrdersHandleProps.currentPage" :per-page="fulfilledOrdersHandleProps.perPage" :total="fulfilled_total">
              </pagination>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>assignment</md-icon>
              </div>
              <h4 class="title">Order Queue</h4>
            </md-card-header>
            <md-card-content>
              <md-table id="orderQueueTable" :value="queuedOrders" :md-sort.sync="queuedOrdersCurrentSort" :md-sort-order.sync="queuedOrdersCurrentSortOrder" :md-sort-fn="queuedCustomSort" class="paginated-table table-striped table-hover">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Order Time">{{ item.order_time | moment }}</md-table-cell>
                  <md-table-cell md-label="Pickup Time">{{ item.pickup_time | moment }}</md-table-cell>
                  <md-table-cell md-label="Merchant Name">{{item.merchant_name}}</md-table-cell>
                  <md-table-cell md-label="Address">{{ item.merchant_address }}</md-table-cell>
                  <md-table-cell md-label="Name">{{ item.order_name }}</md-table-cell>
                  <md-table-cell md-label="Email">{{ item.user_email }}</md-table-cell>
                  <md-table-cell md-label="Platform">{{ item.platform }}</md-table-cell>
                  <md-table-cell md-label="Detail">{{ item.order_details }}</md-table-cell>
                  <md-table-cell md-label="Sub Total">{{ formatDouble(item.sub_total) }}</md-table-cell>
                  <md-table-cell md-label="Tax">{{ formatDouble(item.tax) }}</md-table-cell>
                  <md-table-cell md-label="Tip">{{ formatDouble(item.tip) }}</md-table-cell>
                  <md-table-cell md-label="Fee">{{ formatDouble(item.service_fee) }}</md-table-cell>
                  <md-table-cell md-label="Reward">{{ formatDouble(item.reward_value) }}</md-table-cell>
                  <md-table-cell md-label="Total">{{ formatDouble(item.total_price) }}</md-table-cell>
                  <md-table-cell md-label="Move">
                    <md-button class="md-just-icon md-info md-simple" @click.native="moveOrder(item)">
                      <md-icon>arrow_upward</md-icon>
                    </md-button>
                  </md-table-cell>
                  <md-table-cell md-label="Delete">
                    <md-button class="md-just-icon md-danger md-simple" @click.native="showDeleteConfirm(item, true)">
                      <md-icon>delete</md-icon>
                    </md-button>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <div class="">
                <p class="card-category">
                  Showing {{ queued_orders_from + 1 }} to {{ queued_orders_to }} of {{ queued_total }} entries
                </p>
              </div>
              <pagination class="pagination-no-border pagination-success" v-model="queuedOrdersHandleProps.currentPage" :per-page="queuedOrdersHandleProps.perPage" :total="queued_total">
              </pagination>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment"
import { StatsCard, AnimatedNumber } from "@/components";
import { Pagination } from "@/components";
import { showConfirmationDialog } from '@/components/ActionConfirm';
import DateRangePicker from 'vue2-daterange-picker';
import JsonCSV from 'vue-json-csv'
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'
import MoneyFormatter from "@/mixins/money-formatter-mixin.js"

export default {
  name: "OrderList",
  components: {
    StatsCard,
    AnimatedNumber,
    Pagination,
    DateRangePicker,
    'downloadCsv': JsonCSV
  },
  mixins: [ MoneyFormatter ],
  computed: {
    fulfilled_orders_to() {
      let highBound = this.fulfilled_orders_from + this.fulfilledOrdersHandleProps.perPage;
      if (this.fulfilled_total < highBound) {
        highBound = this.fulfilled_total;
      }
      return highBound;
    },
    queued_orders_to() {
      let highBound = this.queued_orders_from + this.queuedOrdersHandleProps.perPage;
      if (this.queued_total < highBound) {
        highBound = this.queued_total;
      }
      return highBound;
    },
    fulfilled_orders_from() {
      return this.fulfilledOrdersHandleProps.perPage * (this.fulfilledOrdersHandleProps.currentPage - 1);
    },
    queued_orders_from() {
      return this.queuedOrdersHandleProps.perPage * (this.queuedOrdersHandleProps.currentPage - 1);
    },
    queued_total() {
      return this.queued_pagination.total;
    },
    fulfilled_total() {
      return this.fulfilled_pagination.total;
    },
    revenue() {
      var parsedRevenue = parseFloat(this.boxTop.revenue_processed)
      return this.formatter.format(parsedRevenue)
    },
    rewards() {
      var parsedRewards = parseFloat(this.boxTop.rewards_processed)
      return this.formatter.format(parsedRewards)
    },
    fee_revenue() {
      var parsedRevenue = parseFloat(this.boxTop.fee_revenue)
      return this.formatter.format(parsedRevenue)
    },
    downloadTitle() {
      return (this.downloadingCsv ? "Downloading..." : "Download All Data")
    }
  },
  data() {
    return {
      fulfilledOrders: {},
      queuedOrders: {},
      boxTop: {
        revenue_processed: "0.0"
      },
      fulfilledOrdersCurrentSort: "name",
      fulfilledOrdersCurrentSortOrder: "asc",
      queuedOrdersCurrentSort: "names",
      queuedOrdersCurrentSortOrder: "asc",
      fulfilled_pagination: {
        total: 0
      },
      queued_pagination: {
        total: 0
      },
      propsToSearch: ["name"],
      queuedOrdersHandleProps: {
        searchQuery: "",
        currentPage: 1,
        perPage: 25
      },
      fulfilledOrdersHandleProps: {
        searchQuery: "",
        currentPage: 1,
        perPage: 25
      },
      calendarPeriod: {
        startDate: moment().startOf('day'),
        endDate: moment().endOf('day')
      },
      dateStart: moment().startOf('day'),
      dateEnd: moment().endOf('day'),
      calendarLocale: {
        direction: 'ltr',
        format: 'MM/DD/YYYY',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 0,
        showWeekNumbers: true
      },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'This month': [moment().startOf('month'), moment().endOf('month')],
        'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'This year': [moment().startOf('year'), moment().endOf('year')]
      },
      formatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }),
      csvOrders: null,
      downloadingCsv: false,
      exportFields: ['order_time', 'merchant_name', 'merchant_address', 'app_user_id', 'order_name', 'user_email', 'platform', 'sub_total', 'tax', 'tip', 'service_fee', 'reward_value', 'total_price'],
      exportLabels: {
        order_time: 'Order Time',
        merchant_name: 'Merchant',
        merchant_address: 'Address',
        app_user_id: 'User ID',
        order_name: 'Order Name',
        user_email: 'User Email',
        platform: 'Device',
        sub_total: 'Subtotal',
        tax: 'Tax',
        tip: 'Tip',
        service_fee: 'Fee',
        reward_value: 'Reward Value',
        total_price: 'Total Paid'
      }
    }
  },
  created() {
    this.getAllOrderData()
  },
  mounted() {},
  methods: {
    fulfilledCustomSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.fulfilledOrdersCurrentSort;
        if (this.fulfilledOrdersCurrentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    queuedCustomSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.queuedOrdersCurrentSort;
        if (this.queuedOrdersCurrentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    getAllOrderData() {
      // Need to only call one at creation for refresh logic to not log us out
      this.getOrdersSummary(() => {
        this.getCompletedOrders()
        this.getQueuedOrders()
      })
    },
    getCompletedOrders() {
      this.resetCsvButtons()

      this.$http.secured.get(`/v2/admins/orders?order_statuses[]=fulfilled&order_statuses[]=received&order_statuses[]=complete` +
          `&page=${this.fulfilledOrdersHandleProps.currentPage}` +
          `&page_count=${this.fulfilledOrdersHandleProps.perPage}` +
          `&end_date=${moment(this.dateEnd)}&start_date=${this.dateStart}`)
        .then(this.fulfilledSetData)
        .catch(error => alert(error))
    },
    getQueuedOrders() {
      this.$http.secured.get(`/v2/admins/orders?order_statuses[]=queued` +
          `&page=${this.queuedOrdersHandleProps.currentPage}` +
          `&page_count=${this.queuedOrdersHandleProps.perPage}` +
          `&end_date=${this.dateEnd}&start_date=${this.dateStart}`)
        .then(this.queuedSetData)
        .catch(error => alert(error))
    },
    getOrdersSummary(callback) {
      this.$http.secured.get(`/v1/orders/summary?` +
          `&end_date=${this.dateEnd}&start_date=${this.dateStart}`)
        .then(response => {
          this.boxTopValue(response)
          callback()
        })
        .catch(error => alert(error))
    },
    fulfilledSetData(response) {
      this.fulfilledOrders = response.data.orders;
      this.fulfilled_pagination.total = response.data.meta.total
    },
    queuedSetData(response) {
      this.queuedOrders = response.data.orders;
      this.queued_pagination.total = response.data.meta.total
    },
    boxTopValue(response) {
      this.boxTop = response.data;
    },
    downloadCsvData() {
      if (this.downloadingCsv) {
        return
      }

      this.downloadingCsv = true
      this.$http.secured.get(`/v2/admins/orders` +
          `?page=${1}` +
          `&page_count=${100000}` +
          `&end_date=${moment(this.dateEnd)}&start_date=${this.dateStart}`)
        .then((response) => {
          this.csvOrders = response.data.orders

          this.csvOrders.forEach((item, index) => {
            item.order_time = moment(item.order_time).format('MM/DD/YY hh:mm A')
          })
        })
        .catch(error => alert(error))
        .finally(() => this.downloadingCsv = false)
    },
    resetCsvButtons() {
      this.csvOrders = null
      this.downloadingCsv = false
    },
    showDeleteConfirm(order, isQueuedOrder) {
      showConfirmationDialog(() => this.deleteOrder(order, isQueuedOrder))
    },
    moveOrder(order) {
      this.$http.secured.put(`/v1/orders/${order.id}`, { order_status: 2 })
        .then(() => {
          this.queuedOrders.splice(this.queuedOrders.indexOf(order), 1)
          this.getCompletedOrders()
        })
    },
    deleteOrder: function(order, isQueuedOrder) {
      this.$http.secured.delete(`/v1/orders/${order.id}`)
        .then(() => {
          if (isQueuedOrder) {
            this.queuedOrders.splice(this.queuedOrders.indexOf(order), 1)
          } 
          else {
            this.fulfilledOrders.splice(this.fulfilledOrders.indexOf(order), 1)
          }

          this.getOrdersSummary() // Refresh order summary at top
        })
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format('MM/DD/YY hh:mm A');
    }
  },
  watch: {
    queuedOrdersHandleProps: {
      handler() {
        this.getQueuedOrders()
      },
      deep: true
    },
    fulfilledOrdersHandleProps: {
      handler() {
        this.getCompletedOrders()
      },
      deep: true
    },
    calendarPeriod: {
      handler() {
        this.dateStart = moment(this.calendarPeriod.startDate).startOf('day')
        this.dateEnd = moment(this.calendarPeriod.endDate).endOf('day')
        this.getAllOrderData()
      },
      deep: true
    }
  }
}
</script>
<style lang=scss>
.exportBtns {
  margin: 10px auto;
  cursor: pointer;

  i {
    color: white;
    margin-left: 10px;
  }
}

#ordersTable tr td:nth-child(5) {
  max-width: 1% !important;
  white-space: nowrap;
}
#orderQueueTable tr td:nth-child(5) {
  max-width: 1% !important;
  white-space: nowrap;
}
#orderQueueTable.paginated-table .md-table-cell:last-child .md-table-cell-container, .paginated-table .md-table-head:last-child {
  text-align: unset !important;
  justify-content: left;
}

.order-header > .md-card .md-card-header .card-icon, .md-card .md-card-header .card-text {
  margin-right: 0px;
  padding: 10px;
}
</style>